export namespace ISearchSuggestionRequest {
  export enum SuggestionType {
    SUGGESTION_TYPE_UNKNOWN = 'SUGGESTION_TYPE_UNKNOWN',
    SUGGESTION_TYPE_FULL = 'SUGGESTION_TYPE_FULL',
    SUGGESTION_TYPE_BRANDS = 'SUGGESTION_TYPE_BRANDS',
  }

  /**
   * Return an instance of ISearchSuggestionRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISearchSuggestionRequest>
  ): ISearchSuggestionRequest =>
    ({
      ...(partial ?? {}),
    }) as ISearchSuggestionRequest;
}

export interface ISearchSuggestionRequest {
  query: string | undefined;
  /**
   * This used to be a flag for frontend to set for determining if we should return
   * "suggestedSearchQueries", "suggestedCategoryQueries", "suggestedCategories", and "suggestedBrands."
   * We've fully launched the feature, so this flag is no longer useful.
   * @deprecated
   */
  return_default_suggestions: boolean | undefined;
  suggestion_type:
    | keyof typeof ISearchSuggestionRequest.SuggestionType
    | undefined;
}
